<template>
  <el-dialog
    top="80px"
    width="680px"
    class="create-room-type-popup"
    :title="`${!roomType ? 'Tạo mới ' : 'Cập nhật thông tin'}`"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="form"
      class="pt-2 pr-2"
      :model="form"
      :rules="rules"
      label-position="top"
    >
      <el-form-item v-if="!type && !roomType" label="Loại điểm đến" prop="type">
        <el-select
          v-model="form.type"
          filterable
          class="w-100"
          @change="handleChangePlaceType"
        >
          <el-option v-for="t in placeTypes" :key="t.value" :label="t.name" :value="t.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="!type && !roomType" label="Điểm đến" prop="place_id">
        <el-select
          v-model="form.place_id"
          class="w-100"
          filterable
          remote
          placeholder="Chọn điểm đến"
          :remote-method="searchPlace"
          :loading="searching"
        >
          <el-option v-for="p in places" :key="p.id" :label="p.name" :value="p.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Tên" prop="name">
        <el-input
          v-model="form.name"
          :disabled="callingAPI"
          placeholder="Nhập vào tên"
        ></el-input>
      </el-form-item>
      <el-row :gutter="12">
        <el-col :span="8">
          <el-form-item label="Diện tích (m2)" prop="acreage">
            <el-input
              v-model="form.acreage"
              :disabled="callingAPI"
              type="number"
              placeholder="Diện tích phòng"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="Thông tin chung" prop="bed_info">
            <el-input
              v-model="form.bed_info"
              :disabled="callingAPI"
              placeholder="Nhập vào thông tin"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="Link Vrtour" prop="vrtour">
        <el-input
          v-model="form.vrtour"
          :disabled="callingAPI"
          placeholder="Nhập vào link"
        ></el-input>
      </el-form-item>
      <el-form-item label="Mô tả" prop="description">
        <el-input
          v-model="form.description"
          :rows="3"
          :disabled="callingAPI"
          type="textarea"
          placeholder="Nhập mô tả"
        ></el-input>
      </el-form-item>
      <el-form-item label="Tiện ích" prop="facilities">
        <div class="facility-field">
          <div class="facility-actions mb-2 d-flex justify-content-between align-items-center">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-circle-plus-outline"
              :disabled="callingAPI"
              @click="openFacilityPopup"
            >
              Chọn tiện ích
            </el-button>
            <el-button
              v-if="form.facilities"
              type="text"
              size="mini"
              class="text-danger"
              :disabled="callingAPI"
              @click="handleClearFacilities"
            >
              Xóa tất cả
            </el-button>
          </div>
          <div v-if="selectedFacilityList.length" class="facility-tags">
            <el-tag
              v-for="item in selectedFacilityList"
              :key="item.id"
              size="small"
              closable
              class="mr-1 mb-1"
              :disabled="callingAPI"
              @close="handleRemoveFacility(item.id)"
            >
              {{ item.name }}
            </el-tag>
          </div>
          <div v-else class="text-muted" style="font-size: 13px;">
            Chưa có tiện ích nào được chọn
          </div>
        </div>
      </el-form-item>
      <el-form-item label="Thông tin nội dung" prop="content">
        <editor
          v-if="visible"
          editor-key="content"
          :value="form.content"
          @change="(v) => (form.content = v)"
        />
      </el-form-item>
      <el-form-item v-if="roomTypeInfo && visible" lang>
        <audios :data.sync="roomTypeInfo" type="room-type" />
        <documents :data.sync="roomTypeInfo" type="room-type" />
        <pictures :data.sync="roomTypeInfo" type="room-type" />
        <videos :data.sync="roomTypeInfo" type="room-type" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="callingAPI" @click="handleClose">Hủy</el-button>
      <el-button
        v-if="!roomTypeInfo"
        type="primary"
        :loading="callingAPI"
        @click="handleCreateRoomType"
      >Tạo mới</el-button>
      <el-button
        v-else
        type="primary"
        :loading="callingAPI"
        @click="handleUpdateRoomType"
      >Cập nhật</el-button>
    </span>
    <facility-popup
      v-if="facilityVisible"
      :visible="facilityVisible"
      :selected-facility="selectedFacilityIds"
      :place-type="currentPlaceType"
      append-to-body
      @updateFacilities="handleUpdateFacilities"
      @close="facilityVisible = false"
    />
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import Audios from '../cards/Audios.vue'
import Pictures from '../cards/Pictures.vue'
import Videos from '../cards/Videos.vue'
import Documents from '../cards/Documents.vue'
import Editor from '../items/Editor.vue'
import FacilityPopup from './Facility.vue'

import { createRoomType, updateRoomType } from '@/services/room-type'
import { getPlaceTypes, getTranslation } from '@/utils/filters'
import { listPlaces } from '@/services/place'

export default {
  name: 'CreateRoomType',
  components: {
    Audios,
    Pictures,
    Editor,
    Videos,
    Documents,
    FacilityPopup
  },
  props: {
    visible: Boolean,
    roomType: Object,
    object: Object,
    type: String
  },
  data() {
    return {
      callingAPI: false,
      facilityVisible: false,
      places: [],
      searchText: '',
      form: {
        type: this.type || '',
        place_id: this.object ? this.object.id : '',
        name: '',
        acreage: '',
        bed_info: '',
        vrtour: '',
        facilities: '',
        description: '',
        content: ''
      },
      roomTypeInfo: null,
      searching: false,
      rules: {
        type: [
          { required: true, message: 'Loại điểm đến không được để trống', trigger: ['blur', 'change'] }
        ],
        place_id: [
          { required: true, message: 'Điểm đến không được để trống', trigger: ['blur', 'change'] }
        ],
        name: [
          { required: true, message: 'Tên không được để trống', trigger: ['blur', 'change'] }
        ],
        acreage: [
          { required: true, message: 'Diện tích không được để trống', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['language', 'constant']),
    placeFacilities() {
      return (this.constant && this.constant.constants && this.constant.constants.place_facilities) || []
    },
    currentPlaceType() {
      return this.form.type || this.type || (this.object && (this.object.place_type || this.object.type)) || 'stay'
    },
    selectedFacilityIds() {
      if (!this.form.facilities) return []
      const ids = String(this.form.facilities)
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
      const result = []
      ids.forEach((id) => {
        result.push(id)
        const num = Number(id)
        if (!isNaN(num)) {
          result.push(num)
        }
      })
      return result
    },
    selectedFacilityList() {
      if (!this.form.facilities) return []
      const ids = String(this.form.facilities)
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
      if (!ids.length) return []

      return this.placeFacilities
        .filter((f) => ids.some((id) => String(id) === String(f.id)))
        .map((f) => ({
          ...f,
          name: (getTranslation(f, this.language) && getTranslation(f, this.language).name) || f.name
        }))
    },
    placeTypes() {
      return getPlaceTypes(false).filter((p) => p.type === 'place' && p.value === 'stay')
    },
    params() {
      return {
        locale: this.language,
        place_types: this.form.type,
        per_page: 10,
        search_text: this.searchText
      }
    },
    payload() {
      let p = this.roomTypeInfo ? { ...this.roomTypeInfo } : { room_type_id: null }
      p = {
        ...p,
        ...this.form,
        locale: this.language
      }
      if (this.object && this.object.id) {
        return {
          ...p,
          place_id: this.object.id
        }
      }
      return p
    }
  },
  beforeMount() {
    if (!this.type) {
      this.form.type = this.placeTypes[0].value
      this.getPlaces()
    }
    this.loadData()
  },
  methods: {
    loadData() {
      if (this.visible && this.roomType) {
        this.roomTypeInfo = this.roomType
        this.form = {
          name: this.roomType.name,
          acreage: this.roomType.acreage,
          bed_info: this.roomType.bed_info,
          vrtour: this.roomType.vrtour,
          facilities: Array.isArray(this.roomType.facilities)
            ? this.roomType.facilities.join(',')
            : (this.roomType.facilities || ''),
          description: this.roomType.description,
          content: this.roomType.content
        }
      } else {
        this.form = {
          type: this.type || this.placeTypes[0].value,
          place_id: '',
          name: '',
          acreage: 0,
          bed_info: '',
          vrtour: '',
          facilities: '',
          description: '',
          content: ''
        }
        this.roomTypeInfo = null
      }
    },
    openFacilityPopup() {
      if (!this.callingAPI) {
        this.facilityVisible = true
      }
    },
    handleUpdateFacilities(groups) {
      const selectedIds = []
      if (Array.isArray(groups)) {
        groups.forEach((group) => {
          if (group && Array.isArray(group.facilities)) {
            group.facilities.forEach((f) => {
              if (f.checked && f.id !== undefined && f.id !== null) {
                selectedIds.push(f.id)
              }
            })
          }
        })
      }
      this.form.facilities = selectedIds.join(',')
      this.facilityVisible = false
    },
    handleRemoveFacility(idToRemove) {
      const ids = String(this.form.facilities)
        .split(',')
        .map((id) => id.trim())
        .filter((id) => id && String(id) !== String(idToRemove))
      this.form.facilities = ids.join(',')
    },
    handleClearFacilities() {
      this.form.facilities = ''
    },
    handleCreateRoomType() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true
          createRoomType(this.payload).then((response) => {
            this.callingAPI = false
            this.roomTypeInfo = response
            this.$notify.success({
              title: 'Thông báo',
              message: 'Tạo mới thành công'
            })
            this.$emit('reload')
          }).catch((error) => {
            this.callingAPI = false
            this.$notify.error({
              title: 'Thông báo',
              message: error && error.response && error.response.data && error.response.data.message || 'Lỗi hệ thống'
            })
          })
        }
      })
    },
    handleUpdateRoomType() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true
          updateRoomType(this.payload).then(() => {
            this.callingAPI = false
            this.handleClose()
            this.$notify.success({
              title: 'Thông báo',
              message: 'Cập nhật thành công'
            })
            this.$emit('reload')
          }).catch((error) => {
            this.callingAPI = false
            this.$notify.error({
              title: 'Thông báo',
              message: error && error.response && error.response.data && error.response.data.message || 'Lỗi hệ thống'
            })
          })
        }
      })
    },
    getPlaces() {
      this.searching = true
      const request = listPlaces(this.params)
      request.then((res) => {
        this.places = res.result
        this.searching = false
      }).catch(() => {
        this.places = []
        this.searching = false
      })
    },
    handleChangePlaceType() {
      this.form.place_id = ''
      this.searchText = ''
      this.getPlaces()
    },

    searchPlace(text) {
      this.searchText = text
      setTimeout(() => {
        this.getPlaces()
      }, 100)
    },
    handleClose() {
      this.facilityVisible = false
      this.$refs.form.resetFields()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.create-room-type-popup {
  .el-dialog__body {
    max-height: 550px;
    overflow: auto;
  }
  .facility-field {
    .facility-tags {
      max-height: 120px;
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
    }
  }
}
</style>
